import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";

function NewBusinessClientList({ onclose, table_data }) {
  const [data, setData] = useState([]);
  let userLoging = {};
  let currencies = [];
  userLoging = JSON.parse(localStorage.getItem("user") || "{}");
  currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
  const selectedCurrency = currencies.find(
  (currency) =>
    Number(currency.value) === defaultCurrencyId
);
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
  const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
  const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;

  useEffect(() => {
    let data = [];
    table_data?.forEach((item) => {
      data.push({
        client_name: item.name,
        bd_by: item.bd_by,
        revenue: symbol + (item.sum_amount / amountDivisor).toFixed(2),
      });
    });
    setData(data);
  }, [table_data]);

  const columns = [
    {
      accessorKey: "client_name",
      header: "Client Name",
      size: 200,
      Cell: ({ cell }) => <span className="fw-medium">{cell.getValue()}</span>,
    },
    {
      accessorKey: "bd_by",
      header: "Bd By",
      size: 200,
    },
    {
      accessorKey: "revenue",
      header: `Revenue (${amountSuffix})`,
      size: 200,
    },
  ];

  return (
    <>
      <div className="modal fade show d-block" tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">New Business Clients</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onclose}
              ></button>
            </div>
            <div className="modal-body">
              <MaterialReactTable
                columns={columns}
                data={data}
                initialState={{
                  pagination: { pageSize: 30 },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewBusinessClientList;
